import {
  GLOBAL_PREFIX,
  LAYOUT_EMPTY,
  LAYOUT_PUBLIC,
} from '@/router/constants';

const buildMeta = () => ({
  app: 'reviewer',
  title: 'word.research',
  layout: LAYOUT_EMPTY,
  anonymousAllowed: true,
  hideBreadcrumbs: true,
  overlay: 'darker',
});

// Cluster B: de spaarpuntenflow uit ui-v1, in de publieke schil.
const publicMeta = (navRouteActive) => ({
  app: 'reviewer',
  layout: LAYOUT_PUBLIC,
  navRouteActive,
});

const routes = [
  {
    path: `${GLOBAL_PREFIX}/res/:uuid/answers`,
    name: 'reviewer-research-answers',
    component: () => import('@/views/reviewer/ResearchAnswerListView.vue'),
    meta: publicMeta('reviewer-dashboard'),
  },
  {
    path: `${GLOBAL_PREFIX}/dashboard/reviewer`,
    name: 'reviewer-dashboard',
    component: () => import('@/views/reviewer/ReviewerDashboardView.vue'),
    meta: publicMeta('reviewer-dashboard'),
  },
  {
    // Uitgelogd bereikbaar: de Commercial Review-website linkt dit pad publiek.
    // In ui-v1 rendert die pagina dan niets; hier zie je de producten wel, maar
    // zit bestellen achter inloggen. Zie §12c van het migratieplan.
    path: `${GLOBAL_PREFIX}/product-list`,
    name: 'reviewer-product-list',
    component: () => import('@/views/reviewer/ProductListView.vue'),
    meta: { ...publicMeta('reviewer-product-list'), anonymousAllowed: true },
  },
  {
    // "Mijn account" in de reviewersomgeving: dezelfde pagina als `user-profile`,
    // maar met de sidebar van de respondent. Via `user-profile` kreeg iemand met
    // een membership de donkere sidebar van het bedrijf.
    path: `${GLOBAL_PREFIX}/account`,
    name: 'reviewer-user-profile',
    component: () => import('@/views/shared/UserProfileView.vue'),
    meta: { ...publicMeta('reviewer-user-profile'), title: 'phrase.my_account' },
  },
  {
    // Het activeren is een modal op "Mijn coins" geworden. Het pad blijft, want
    // de backend stuurt het oude /activate-coin-account/ hierheen (#1068).
    path: `${GLOBAL_PREFIX}/activate-coin-account`,
    name: 'reviewer-activate-coin-account',
    redirect: (to) => ({ name: 'reviewer-dashboard', query: to.query }),
    meta: { hideBreadcrumbs: true },
  },
  {
    path: `${GLOBAL_PREFIX}/res/:uuid`,
    name: 'reviewer-review-research',
    component: () => import('@/views/reviewer/ReviewResearchView.vue'),
    meta: { ...buildMeta(), overlay: 'lighter' },
  },
  {
    path: `${GLOBAL_PREFIX}/res/:uuid/removed`,
    name: 'reviewer-removed-from-research',
    component: () => import('@/views/reviewer/RemovedFromResearchView.vue'),
    meta: buildMeta(),
  },
  {
    path: `${GLOBAL_PREFIX}/res/:uuid/quality-terminated`,
    name: 'reviewer-quality-terminated',
    component: () => import('@/views/reviewer/QualityTerminatedView.vue'),
    meta: buildMeta(),
  },
  {
    path: `${GLOBAL_PREFIX}/max-reviews`,
    name: 'reviewer-max-reviews',
    component: () => import('@/views/reviewer/MaxReviewsView.vue'),
    meta: buildMeta(),
  },
  {
    path: `${GLOBAL_PREFIX}/own-commercial`,
    name: 'reviewer-own-commercial',
    component: () => import('@/views/reviewer/OwnCommercialView.vue'),
    meta: buildMeta(),
  },
  {
    path: `${GLOBAL_PREFIX}/research-set/:uuid/review`,
    name: 'reviewer-research-set-review',
    component: () => import('@/views/reviewer/ResearchSetReviewView.vue'),
    meta: buildMeta(),
  },
  {
    path: `${GLOBAL_PREFIX}/external/:slug/start`,
    name: 'reviewer-external-start',
    component: () => import('@/views/reviewer/ExternalInitView.vue'),
    meta: buildMeta(),
  },
  {
    path: `${GLOBAL_PREFIX}/external-start/:researchSetUuid`,
    name: 'reviewer-external-v2-start',
    component: () => import('@/views/reviewer/ExternalStartSessionView.vue'),
    meta: buildMeta(),
  },
];

export default routes;
